import React, { Component } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import styled from 'styled-components';
import {Bar} from 'react-chartjs-2';
import {Box, MainHeading, BoxContent, NoData} from '../../StyledComponents';


/**
* Colors
*/
const themeColors = ['#9674a0', '#d26565', '#add3fb', '#55ba9a', '#1865bd', '#f07839', '#7b4172', '#e7969c', '#a55094', '#843c39'];


/**
* Styled components
*/
const BarChartViewContainer = styled.div`
  /*
    display: flex;
    flex-direction: column;
    flex: 1;
  */
`;

const BarChartContainer = styled.div`
  /*
    display: flex;
    flex-direction: column;
    flex: 1;
    padding-left: 15%;
    padding-right: 15%;
  */
  padding-top: 20px;
  @media only screen and (max-width: 767px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const ChartDataContainer = styled.div`
  /*
    display: flex;
    flex-direction: column;
    flex: 1;
  */
`;

const ChartContainer = styled.div`
  flex: 1;
  max-height: 200px;
`;

const DataContainer = styled.div`
  /*
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    margin-top: 40px;
    padding-left: 12%;
    padding-right: 12%;
  */
  @media only screen and (max-width: 767px) {
    padding-left: 0;
    padding-right: 0;
  }
`;

const DataInnerContainer = styled.div`

`;

const IconRow = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 8px;
`;

const IconData = styled.span`
  margin-right: 5px;
  height: 12px;
  width: 12px;
  border-radius: 50% !important;
  display: inline-block;
`;

const TitleData = styled.p`
  color: #c3c3c3;
  line-height: 12px;
  margin-bottom: 0;
`;


/**
* Class BarChartView
*/
class BarChartView extends Component {

  constructor(props) {
    super(props)
    this.translateData = this.translateData.bind(this);
    this.renderChartData = this.renderChartData.bind(this);
  }

  translateData(data) {
    let chartData = {
      labels: [],
      datasets: [{
        data: [],
        backgroundColor: [],
        hoverBackgroundColor: [],
        borderColor: [],
      }],
    };
    const dataValues = data.values;
    for(let i = 0; i < dataValues.length; i++) {
      chartData.labels[i] = dataValues[i].name;
      chartData.datasets[0].data[i] = dataValues[i].value;
      chartData.datasets[0].backgroundColor[i] = themeColors[i];
      chartData.datasets[0].hoverBackgroundColor[i] = themeColors[i];
      chartData.datasets[0].borderColor[i] = themeColors[i];
    }
    return chartData;
  }

  /*
  * TODO: add a datatype check (data.type == 'media-distribution') and if true use image. Solution depends on the structure of the incoming data
  * data.type == 'media-distribution' ? <ImgData /> : <IconData />
  */
  renderChartData(data) {
    let values = data.values;
    return _.map(values, (dataValue, key) => {
      return (
        <DataInnerContainer key={key}>
          <IconRow>
            <IconData style={{backgroundColor: themeColors[key] }}></IconData>
            <TitleData className="small-font-size">{dataValue.name}</TitleData>
          </IconRow>
        </DataInnerContainer>
      );
    });
  }

  render() {
    const { data, printBreak } = this.props;
    const disabledViews = (this.props.user.client && this.props.user.client.viewSettings && this.props.user.client.viewSettings.disabledViews) || [];
    const disabled = !data || disabledViews.indexOf(this.props.id) > -1;

    const placeholderData = {
        "type": "chart",
        "title": "Products",
        "description": "",
        "values": [
          {
            "name": "Product A",
            "value": 122
          },
          {
            "name": "Product B",
            "value": 93
          },
          {
            "name": "Product C",
            "value": 84
          }
        ]
      };

    const chartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false,
        labels: {
          usePointStyle: true,
          fontColor: '#c3c3c3',
        },
        position: 'right',
      },
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true
          },
          gridLines: {
            color: '#333333',
            zeroLineColor: '#777777',
            lineWidth: 0.5,
          }
        }],
        xAxes: [{
          display: false,
        }]
      }
    }

    const _data = data || placeholderData;
    const chartData = _data ? this.translateData(_data) : {};

    return (
      <Box className={printBreak ? 'print-page-break-after' : ''} {...this.props}>
        <BarChartViewContainer>
            <MainHeading>{disabled ? (this.props.title || _data.title):_data.title}</MainHeading>
          <BoxContent disabled={disabled}>
          <BarChartContainer>

            {/* }<ChartDescription>{_data && _data.description}</ChartDescription>*/}

            {_data && (
              <ChartDataContainer className="row">
                <ChartContainer className="col-xs-12 col-sm-12 col-md-8">
                  <Bar data={chartData} options={chartOptions} />
                </ChartContainer>
                <DataContainer className="col-xs-12 col-sm-12 col-md-4">
                  {this.renderChartData(_data)}
                </DataContainer>
              </ChartDataContainer>
            )}

          </BarChartContainer>
          </BoxContent>
          {disabled && <NoData/>}

        </BarChartViewContainer>
      </Box>
    );

  }
}

function mapStateToProps(state, ownProps) {
    return {
        uid: state.user.uid,
        user: state.user
    };
}

export default connect(mapStateToProps)(BarChartView);



// WEBPACK FOOTER //
// ./src/components/dataViews/detailViews/BarChartView.js